export const GROUP_STATUS_OPTIONS = [
  { value: 0, label: '대기' },
  { value: 1, label: '진행' },
  { value: 2, label: '종료' },
];

export const COMPLETION_VIDEO = 'VIDEO';
export const COMPLETION_DIAGNOSTIC = 'DIAGNOSTIC';
export const COMPLETION_ASSIGNMENT = 'ASSIGNMENT';

export const COMPLETION_REQUIREMENTS_OPTIONS = [
  { value: 'VIDEO', label: '동영상 강의', disable: false, helper: '과정을 선택해야 합니다.' },
  { value: 'ASSIGNMENT', label: '과제 제출', disable: true, hidden: true },
  { value: 'DIAGNOSTIC', label: '진단 및 대응훈련', disable: false, helper: '훈련이 필요한 과정을 선택해야 합니다.' },
  { value: 'IDE', label: '프로젝트 개발훈련', disable: true },
  { value: 'EXAM', label: '역량평가', disable: false },
];

/** 그룹 등록/수정 화면에서 선택 가능한 수료 조건 */
export const getSelectableCompletionRequirements = () =>
  COMPLETION_REQUIREMENTS_OPTIONS.filter((option) => !option.hidden);

/** 더 이상 사용하지 않는 과제 제출 조건을 저장 값에서 제거한다. */
export const sanitizeCompletionRequirements = (requirements) =>
  (Array.isArray(requirements) ? requirements : []).filter(
    (value) => value !== COMPLETION_ASSIGNMENT
  );